import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import ErrorBoundary from './components/base/ErrorBoundary';
import { useEffect, Suspense } from 'react';
import LoadingSpinner from './components/base/LoadingSpinner';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <Suspense fallback={<LoadingSpinner />}>
          <AppRoutes />
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
